enum FundingMechanisms {
  Apprenticeship = 'apprenticeship',
  CPF = 'cpf',
  Default = 'default',
}

export default FundingMechanisms;
